import classNames from "classnames";
const Overlap = ({
  className,
  isActive,
}: {
  className?: string;
  isActive: boolean;
}) => (
  <svg
    width={109}
    height={44}
    viewBox="0 0 109 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames(className, {
      "gg-fill-dark-blue": !isActive,
      "gg-fill-[#e5e5f1]": isActive,
    })}
  >
    <g fillRule="evenodd" clipRule="evenodd">
      <path d="M0 14h13a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H0v4h11v6H0zm109 0H96a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h13v4H98v6h11z" />
      <path d="M12 17a1 1 0 0 1 1-1h83a1 1 0 1 1 0 2H13a1 1 0 0 1-1-1" />
    </g>
  </svg>
);
export default Overlap;
